/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AddCloudDesktopIcon = /*#__PURE__*/ createSvgIcon(
  'AddCloudDesktopIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.27 15.06a.5.5 0 01.5-.5h2.46a.5.5 0 010 1H8.77a.5.5 0 01-.5-.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.707 11.5H17.25l2.25 3.937V17.5H.5v-2.06l2.207-3.94zm.586 1L1.5 15.7v.8h17v-.797L16.67 12.5H3.293z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 2.5h14.96v10H2.5v-10zm1 1v8h12.96v-8H3.5z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 9.5v-4h1v4h-1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 8H8V7h4v1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AddCloudDesktopIcon;
